import * as CookieConsent from "vanilla-cookieconsent";

//flags for turning ON/OFF consent for analytics tracking

export const GA_AFFILIATE_MARKETING_REQUIRES_CONSENT = true;
export const GA_INTERNAL_REQUIRES_CONSENT = false;
export const BING_REQUIRES_CONSENT = true;
export const META_REQUIRES_CONSENT = true;
export const GA_REGISTRATION_TRACKING_REQUIRES_CONSENT = true;

//bump number up when cookie usage or any of the flags above changes,
//so users get prompted for consent again
export const COOKIE_CONSENT_REVISION = 3;

const CONSENT_COOKIE_NAME = "cc_cookie";

export type AnalyticsConsentCategory = "ads" | "analytics";

export const isAnalyticsConsentSatisfied = (
	requiresConsent: boolean,
	category: AnalyticsConsentCategory
): boolean => {
	if (!requiresConsent) {
		return true;
	}

	try {
		if (CookieConsent.acceptedCategory(category)) {
			return true;
		}
	} catch {}

	return readValidStoredCategories().includes(category);
};

function readValidStoredCategories(): string[] {
	try {
		const cookieEntry = document.cookie
			.split(";")
			.map((entry) => entry.trim())
			.find((entry) => entry.startsWith(`${CONSENT_COOKIE_NAME}=`));

		if (!cookieEntry) {
			return [];
		}

		const consent = JSON.parse(
			decodeURIComponent(
				cookieEntry.slice(CONSENT_COOKIE_NAME.length + 1)
			)
		);

		if (
			!consent?.consentId ||
			consent.revision !== COOKIE_CONSENT_REVISION
		) {
			return [];
		}

		return Array.isArray(consent.categories) ? consent.categories : [];
	} catch {
		return [];
	}
}
